export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
export const DOWN = 'DOWN';
export const UP = 'UP';

export const CLASSIC = 'classic';
export const HIGHLIGHT = 'highlight';
export const PREMIUM = 'premiumchannel';
export const CATEGORY = 'category';
export const RECORDINGS = 'recordings';
export const MORETOP = 'Carrousellomastop';
export const MOREPOPULAR = 'Carrouselverticalampliado';
export const TALENTS = 'tooncharacter';
export const INFINITE = 'infinite';
export const LIVECHANNEL = 'livechannel';
export const VOID = 'void';
export const MIS_AQUILERES = 'Mis-aquileres';
export const PORGRABAR = 'Por-grabar';

//MUNDIAL
export const MUNDIALSOCCERMATCHER = 'soccermatcher';
export const MUNDIALSOCCERTEAMS = 'soccerteams';
export const MUNDIALPLAYERS = 'soccerPlayers';
export const URLRIBBONMATCHES = '/mundial/vcardmatch/';
export const URLVCARDJPLAYER = '/mundial/vcard-jugador/';
export const URLVCARDDIRECTOR = '/mundial/vcard-director/';
export const COMPLETED = 'COMPLETED'
export const COACH = 'COACH'
export const VCARDMATCH = 'vcardmatch'

export const FAVORITED_API = '/user/favorited';
export const FAVORITED_API_V1 = '/user/v1/favorited';
export const SEEN_API = '/user/seen';
export const SEEN_API_V1 = '/user/v1/seen';
export const RECORDINGS_API = '/recordings';
export const LIVECHANNEL_API = '/user/livechannel';
export const LIVECHANNEL_API_V1 = '/user/v1/livechannel';

export const VISIBLE_NUMBER_HIGHLIGHT = 3;
export const VISIBLE_NUMBER_PREMIUM = 4;
export const VISIBLE_NUMBER_CLASSIC = 5;
export const VISIBLE_NUMBER_CATEGORY = 20;
export const VISIBLE_NUMBER_TALENTS = 8;
export const VISIBLE_NUMBER_POPULAR = 6;
export const VISIBLE_NUMBER_PLAYERS = 7;
export const VISIBLE_NUMBER_TOP = 10;
export const VISIBLE_NUMBER_MUNDIAL_SOCCERMATCHER = 4;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/constants.js